module.exports = __webpack_public_path__ + "img/tv.aaf8baef.svg";